import {BaseContainerModel} from '../base-container.model';
import {app_login_provider_app_hdr_RowClass} from '../../dbschema';
import {app_login_provider_app_line_RowClass} from '../../dbschema';
import {app_login_provider_app_ext_RowClass} from '../../dbschema';

export class AppLoginProviderAppContainerModel extends BaseContainerModel {
  app_login_provider_app_hdr: app_login_provider_app_hdr_RowClass = new app_login_provider_app_hdr_RowClass();
  app_login_provider_app_lines: app_login_provider_app_line_RowClass[] = [];
  app_login_provider_app_exts: app_login_provider_app_ext_RowClass[] = [];
}
